// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hptB55GiM0HjF62RL4YL {
  width: 100%;
  font-size: 1rem;
  border: var(--dry-border);
  border-radius: var(--dry-border-radius);
  background-color: var(--dry-control-bg);
  color: var(--color);
  padding: 0 0.2em;
  font-size: 0.9rem;
}
.hptB55GiM0HjF62RL4YL.error {
  border-color: var(--dry-error-text);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `hptB55GiM0HjF62RL4YL`,
	"error": `error`
};
export default ___CSS_LOADER_EXPORT___;
